// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ar-4";
export var closeButton = "_ar-6";
export var dismissButton = "_ar-3";
export var editImageWithAiContainer = "_ar-8";
export var imageUploadWrapper = "_ar-7";
export var misspelledWord = "_ar-5";
export var spellCheckContainer = "_ar-2";
export var spin = "_ar-1";
export var spinning = "_ar-0";